<template>
  <section class="who-we-are section" id="who-we-are">
    <div class="wrapper">
      <div class="row center-xs middle-xs">
        <div class="col-md-2 col-sm-12 col-xs-12 item">
            <h2 class="title">Quem somos</h2>
        </div>
        <div class="col-md-1 col-sm-12 col-xs-12 item">
          <span class="separator rotate"></span>
        </div>
        <div class="col-md-9 col-sm-12 col-xs-12 item">
          <div class="text" v-html="api.quem_somos_texto">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'QuemSomos',
  props: ['api'],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
  #who-we-are
    padding 150px 0
    .text
      text-align left
    h2
      white-space nowrap
      position relative
      top 135px
      transform rotate(-90deg)
    @media (max-width 940px)
      .rotate, .title
        transform rotate(0deg)
        top 0
        left 0
        margin 0
      .separator
        margin 20px auto
</style>



// WEBPACK FOOTER //
// src/components/WhoWeAreSection.vue